module.exports = __webpack_public_path__ + "img/source05_01.23185272.png";